import { buildRunIdParam } from 'src/common/helpers/GQLRequestsHelper/buildRunIdParam';

import { MobileSdkTestFilterOptionsQueryVariables } from '../MobileSdkTestFilterOptions.generated';

export const buildMobileSdkTestFilterOptionsVariables = (
	testId: string
): MobileSdkTestFilterOptionsQueryVariables => {
	return {
		testId: buildRunIdParam(testId).runId
	};
};
